var map = {
	"./asteroid(green)-slowed@2x__00000.png": 618,
	"./asteroid(green)-slowed@2x__00001.png": 619,
	"./asteroid(green)-slowed@2x__00002.png": 620,
	"./asteroid(green)-slowed@2x__00003.png": 621,
	"./asteroid(green)-slowed@2x__00004.png": 622,
	"./asteroid(green)-slowed@2x__00005.png": 623,
	"./asteroid(green)-slowed@2x__00006.png": 624,
	"./asteroid(green)-slowed@2x__00007.png": 625,
	"./asteroid(green)-slowed@2x__00008.png": 626,
	"./asteroid(green)-slowed@2x__00009.png": 627,
	"./asteroid(green)-slowed@2x__00010.png": 628,
	"./asteroid(green)-slowed@2x__00011.png": 629,
	"./asteroid(green)-slowed@2x__00012.png": 630,
	"./asteroid(green)-slowed@2x__00013.png": 631,
	"./asteroid(green)-slowed@2x__00014.png": 632,
	"./asteroid(green)-slowed@2x__00015.png": 633,
	"./asteroid(green)-slowed@2x__00016.png": 634,
	"./asteroid(green)-slowed@2x__00017.png": 635,
	"./asteroid(green)-slowed@2x__00018.png": 636,
	"./asteroid(green)-slowed@2x__00019.png": 637,
	"./asteroid(green)-slowed@2x__00020.png": 638,
	"./asteroid(green)-slowed@2x__00021.png": 639,
	"./asteroid(green)-slowed@2x__00022.png": 640,
	"./asteroid(green)-slowed@2x__00023.png": 641,
	"./asteroid(green)-slowed@2x__00024.png": 642,
	"./asteroid(green)-slowed@2x__00025.png": 643,
	"./asteroid(green)-slowed@2x__00026.png": 644,
	"./asteroid(green)-slowed@2x__00027.png": 645,
	"./asteroid(green)-slowed@2x__00028.png": 646,
	"./asteroid(green)-slowed@2x__00029.png": 647,
	"./asteroid(green)-slowed@2x__00030.png": 648,
	"./asteroid(green)-slowed@2x__00031.png": 649,
	"./asteroid(green)-slowed@2x__00032.png": 650,
	"./asteroid(green)-slowed@2x__00033.png": 651,
	"./asteroid(green)-slowed@2x__00034.png": 652,
	"./asteroid(green)-slowed@2x__00035.png": 653,
	"./asteroid(green)-slowed@2x__00036.png": 654,
	"./asteroid(green)-slowed@2x__00037.png": 655,
	"./asteroid(green)-slowed@2x__00038.png": 656,
	"./asteroid(green)-slowed@2x__00039.png": 657,
	"./asteroid(green)-slowed@2x__00040.png": 658,
	"./asteroid(green)-slowed@2x__00041.png": 659,
	"./asteroid(green)-slowed@2x__00042.png": 660,
	"./asteroid(green)-slowed@2x__00043.png": 661,
	"./asteroid(green)-slowed@2x__00044.png": 662,
	"./asteroid(green)-slowed@2x__00045.png": 663,
	"./asteroid(green)-slowed@2x__00046.png": 664,
	"./asteroid(green)-slowed@2x__00047.png": 665,
	"./asteroid(green)-slowed@2x__00048.png": 666,
	"./asteroid(green)-slowed@2x__00049.png": 667,
	"./asteroid(green)-slowed@2x__00050.png": 668,
	"./asteroid(green)-slowed@2x__00051.png": 669,
	"./asteroid(green)-slowed@2x__00052.png": 670,
	"./asteroid(green)-slowed@2x__00053.png": 671,
	"./asteroid(green)-slowed@2x__00054.png": 672,
	"./asteroid(green)-slowed@2x__00055.png": 673,
	"./asteroid(green)-slowed@2x__00056.png": 674,
	"./asteroid(green)-slowed@2x__00057.png": 675,
	"./asteroid(green)-slowed@2x__00058.png": 676,
	"./asteroid(green)-slowed@2x__00059.png": 677
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 617;


//////////////////
// WEBPACK FOOTER
// ./src/assets/asteroid-slowed-green nonrecursive \.(png)$
// module id = 617
// module chunks = 0